import { render, staticRenderFns } from "./Tagset.vue?vue&type=template&id=9ac98eae&scoped=true&"
import script from "./Tagset.vue?vue&type=script&lang=js&"
export * from "./Tagset.vue?vue&type=script&lang=js&"
import style0 from "./Tagset.vue?vue&type=style&index=0&id=9ac98eae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac98eae",
  null
  
)

export default component.exports